export default __webpack_public_path__ + "static/media/eva.258d5c64.jpg";